import React from "react";
import { Card, Row, Col, Button, Typography, Tag, Tooltip } from "antd";
import "./user.css";
import moment from "moment";
const { Text } = Typography;

class UserInfo extends React.Component {
  state = {
    userDetail: {},
    countryList: [],
  };

  componentDidMount() {
    console.log(this.props.detail);

    this.setState({
      userDetail: this.props.detail,
      countryList: this.props.countryList,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.detail !== nextProps.detail) {
      this.setState({ userDetail: nextProps.detail });
    }
  }

  _findCountryName = (regionCode) => {
    if (!regionCode) return "-";
    const country = this.state.countryList.find((c) => {
      return c.region_code === regionCode.toUpperCase();
    });
    return country.name || "-";
  };

  _decimalPrice = (amount) => {
    if (!amount) return "-";

    return amount.toFixed(4);
  };

  _editUserInfo = () => {
    this.props.onEdit();
  };

  _addUserCredit = () => {
    this.props.onAddCredit();
  };

  _viewUserOffer = () => {
    this.props.onViewUserOffer();
  };

  _viewHistory = () => {
    this.props.onViewHistory();
  };

  getDetailPaymentType = () => {
    if (this.state.userDetail.is_postpaid === 1) return "Prepaid";
    return `Postpaid (${this.state.userDetail.payment_term} days)`;
  };

  getSalesName = () =>
    this.state.userDetail.sale_owner_id
      ? this.props.getSalesName(this.state.userDetail.sale_owner_id)
      : "-";

  getFeeAmount = () =>
    !this.state.userDetail.fee_amount
      ? "-"
      : `$ ${this.state.userDetail.fee_amount}`;

  _lebelSenderAllow = (fpbf) => {
    if (!fpbf) {
      return "-";
    }

    if (fpbf.is_allow === 1) {
      return (
        <Tooltip title={fpbf.status || ""}>
          <Tag color="lime">ALLOWED</Tag>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={fpbf.status || ""}>
          <Tag color="volcano">NOT ALLOWED</Tag>
        </Tooltip>
      );
    }
  };

  _switchSenderAllow = () => {
    this.props.onSwitchAllowStatus();
  };

  aging = (date) => {
    const createdDate = moment(date, "DD-MM-YYYY");
    const now = moment(new Date(), "DD-MM-YYYY");
    const monthDiff = now.diff(createdDate, "months");
    let aging = "";
    if (monthDiff <= 11) {
      aging = <span style={{ fontWeight: "600" }}>(&le; 1Y)</span>;
    } else if (monthDiff > 11 && monthDiff <= 23) {
      aging = <span style={{ fontWeight: "600" }}>(&le; 2Y)</span>;
    } else {
      aging = <span style={{ fontWeight: "600" }}>(+2Year)</span>;
    }

    return aging;
  };

  render() {
    return (
      <div>
        <Row>
          <Col span={12}>
            <Text strong>Customer Infomation</Text>
          </Col>
          <Col span={12} className={"text-right"}>
            <Button
              style={{ marginRight: 8 }}
              icon="history"
              onClick={() => this._viewHistory()}
            >
              View History
            </Button>
            <Button
              type="primary"
              icon="edit"
              onClick={() => this._editUserInfo()}
            >
              Edit
            </Button>
          </Col>
        </Row>
        <Row className="user-info">
          <Col>
            <Card>
              <Row>
                <Col span={12}>Created Date</Col>
                <Col span={12}>
                  {this.state.userDetail.created
                    ? `${this.state.userDetail.created}`
                    : "-"}{" "}
                  {this.aging(this.state.userDetail.created)}
                </Col>
              </Row>
              <Row>
                <Col span={12}>Priority</Col>
                <Col span={12}>
                  <span style={{ fontWeight: "600" }}>
                    {this.state.userDetail.priority}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col span={12}>Member-ID</Col>
                <Col span={12}>{this.state.userDetail.id}</Col>
              </Row>
              <Row>
                <Col span={12}>Name</Col>
                <Col span={12}>
                  {this.state.userDetail.firstname +
                    " " +
                    this.state.userDetail.lastname}
                </Col>
              </Row>
              <Row>
                <Col span={12}>Email</Col>
                <Col span={12}>{this.state.userDetail.email || "-"}</Col>
              </Row>
              <Row>
                <Col span={12}>Phone</Col>
                <Col span={12}>{this.state.userDetail.tel || "-"}</Col>
              </Row>
              <Row>
                <Col span={12}>Office</Col>
                <Col span={12}>{this.state.userDetail.company_name || "-"}</Col>
              </Row>
              <Row>
                <Col span={12}>Country</Col>
                <Col span={12}>
                  {this._findCountryName(this.state.userDetail.country)}
                </Col>
              </Row>
              <Row>
                <Col span={12}>Address</Col>
                <Col span={12}>{this.state.userDetail.address || "-"}</Col>
              </Row>
              <Row>
                <Col span={12}>Post Code</Col>
                <Col span={12}>{this.state.userDetail.zip_code || "-"}</Col>
              </Row>
              <Row>
                <Col span={12}>Registered IP Adderss</Col>
                <Col span={12}>
                  {this.state.userDetail.registered_ip || "-"}
                </Col>
              </Row>
              <Row>
                <Col span={12}>Payment Type</Col>
                <Col span={12}>{this.getDetailPaymentType()}</Col>
              </Row>
              <Row>
                <Col span={12}>Sales Owner</Col>
                <Col span={12}>{this.getSalesName()}</Col>
              </Row>
              <Row>
                <Col span={12}>Channel</Col>
                <Col span={12}>{this.state.userDetail.channel || "-"}</Col>
              </Row>
              <Row>
                <Col span={12}>Blocked Date</Col>
                <Col span={12}>{this.state.userDetail.blocked_date || "-"}</Col>
              </Row>
              <Row>
                <Col span={12}>Viber Register Fee</Col>
                <Col span={12}>{this.getFeeAmount() || "-"}</Col>
              </Row>
              <Row>
                <Col span={12}>Revision</Col>
                <Col span={12}>
                  {this.state.userDetail.price_sell_group
                    ? this.state.userDetail.price_sell_group.name
                    : "-"}
                </Col>
              </Row>
              <Row>
                <Col span={12}>Member's Notify</Col>
                <Col span={12} style={{ overflowX: "clip" }}>
                  Email:{" "}
                  {this.state.userDetail.notify_member &&
                  this.state.userDetail.notify_member.email &&
                  this.state.userDetail.notify_member.email.length
                    ? this.state.userDetail.notify_member.email.join(",")
                    : this.state.userDetail.email}
                </Col>
                <Col push={12} span={12}>
                  Balance:{" "}
                  {this.state.userDetail.notify_member
                    ? this.state.userDetail.notify_member.balance > 0
                      ? this.state.userDetail.notify_member.balance
                      : "30"
                    : "30"}
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row className="shotcut-action" type="flex" align="middle">
          <Col span={8}>
            <Text strong>Avilable Balance</Text>
          </Col>
          <Col span={16}>
            <Card>
              <Row type="flex" align="middle">
                <Col span={12}>
                  ${this._decimalPrice(this.state.userDetail.balance)}
                </Col>
                <Col span={12} className={"text-right"}>
                  <Button type="primary" onClick={() => this._addUserCredit()}>
                    Add Credit
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row className="shotcut-action" type="flex" align="middle">
          <Col span={8}>
            <Text strong>Special Price</Text>
          </Col>
          <Col span={16}>
            <Card>
              <Row type="flex" align="middle">
                <Col span={12}>
                  {this.state.userDetail.special_offer} Offers
                </Col>
                <Col span={12} className={"text-right"}>
                  <Button type="primary" onClick={() => this._viewUserOffer()}>
                    View Offer
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row className="shotcut-action" type="flex" align="middle">
          <Col span={8}>
            <Text strong>Sender Allow</Text>
          </Col>
          <Col span={16}>
            <Card>
              <Row type="flex" align="middle">
                <Col span={12}>
                  {this._lebelSenderAllow(this.state.userDetail.fpbf)}
                </Col>
                <Col span={12} className={"text-right"}>
                  <Button
                    type="primary"
                    onClick={() => this._switchSenderAllow()}
                  >
                    Switch Status
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default UserInfo;



// WEBPACK FOOTER //
// ./src/containers/User/user-info.js